// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fill-height[data-v-7659fa7c]{height:70vh}.v-item-group[data-v-7659fa7c] .v-slide-group__next,.v-item-group[data-v-7659fa7c] .v-slide-group__prev{min-width:15px}", ""]);
// Exports
module.exports = exports;
